/* The per-person grants, as reference data for «Матрица доступа».
 *
 * The matrix itself is no longer kept here. It used to be PRD §3 transcribed —
 * five fixed columns and hand-written levels — and it drifted from the roles it
 * described once roles became editable rows (migration 0021): a role a founder
 * created had no column, and seeded cells disagreed with the stored grants
 * (N-09). `AccessMatrixPanel` now builds the table from `GET /admin/roles`, the
 * same records the role editor writes, so there is no second copy here to
 * disagree with them.
 *
 * What stays is the list of legacy grants, because they are not part of any
 * role: additive booleans on the user record, assigned per person in
 * Settings → Users (S-7). Nothing here is consulted to decide access —
 * authorization is the server's alone (AD-21).
 *
 * Labels are i18n keys rather than text: this is module-level data evaluated
 * once at import, so a translated string baked in here would freeze in whatever
 * language was active at startup (the same reason navigation.ts holds keys).
 */

/** The FR-44 grants. Additive booleans on the user record, never roles —
 *  which is why they are listed apart from the matrix rather than as columns in
 *  it. Assigned per user in Settings → Users (S-7), not here. */
export const GRANTS = [
  {
    id: 'manageClients',
    labelKey: 'directories.users.grantLabels.manageClients',
    descriptionKey: 'settings.access.grants.manageClients',
  },
  {
    id: 'manageParticipants',
    labelKey: 'directories.users.grantLabels.manageParticipants',
    descriptionKey: 'settings.access.grants.manageParticipants',
  },
  {
    id: 'manageTransport',
    labelKey: 'directories.users.grantLabels.manageTransport',
    descriptionKey: 'settings.access.grants.manageTransport',
  },
] as const
